<template>
  <div class="template">
    <div class="title">
      <span>应用组件</span>
      <!-- <span class="title-count">已选 {{ selectedIds.length }}/8</span> -->
    </div>
    <!-- <div class="title-tip">单页最多展示 8 个模块</div> -->
    <el-tabs v-model="activeTab" class="template-tabs">
      <el-tab-pane 
        v-for="typeGroup in groupedApplications" 
        :key="typeGroup.type" 
        :label="typeGroup.type" 
        :name="typeGroup.type"
      >
        <draggable
          class="list"
          v-model="typeGroup.items"
          draggable=".drag-item"
          :sort="false"
          :group="{ name: group, pull: 'clone', put: false }"
          item-key="id"
        >
          <template #item="{ element }">
            <div
              :class="[
                'template-application-category-item',
                {
                  'drag-item': !disabled && !isSelected(element.id),
                  'is-selected': isSelected(element.id),
                }
              ]"
            >
              <svg-icon :name="element.icon" class="item-icon" />
              <span class="item-name" :title="element.name">{{ element.name }}</span>
              <span v-if="isSelected(element.id)" class="drag-item-check">已选</span>
            </div>
          </template>
        </draggable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import draggable from 'vuedraggable'
import { ref, computed } from 'vue'
import { applicationList } from '@/components/Application'

const props = defineProps({
  group: {
    type: String,
    default: '',
  },
  templateData: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false
  },
  fileItems: {
    type: Array,
    default: () => []
  }
})

const activeTab = ref('')

const groupedApplications = computed(() => {
  const baseTypes = applicationList
    .map(item => item.type)
    .filter(type => type !== '文件类')
  const types = props.fileItems?.length
    ? ['文件类', ...new Set(baseTypes)]
    : [...new Set(applicationList.map(item => item.type))]
  
  if (!activeTab.value && types.length > 0) {
    activeTab.value = types[0]
  }
  
  return types.map(type => ({
    type,
    items: type === '文件类' && props.fileItems?.length
      ? props.fileItems
      : applicationList.filter(item => item.type === type)
  }))
})

const selectedIds = computed(() => {
  const result = []
  props.templateData?.forEach(row => {
    row.forEach(item => {
      if (!item.isMerge && item.items?.length) {
        result.push(item.items?.[0]?.id)
      }
    })
  })
  return result
})

const isSelected = (id) => selectedIds.value.includes(id)
</script>

<style scoped lang="scss">
.template {
  flex: 1;
  padding: 0 10px;
  background-image: url('../../assets/images/componentborder.png');
  background-size: 100% 100%;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0 6px;
}

.title-count {
  font-size: 12px;
  color: #6b7280;
}

.title-tip {
  padding: 0;
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 12px;
}
.list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.template-application-category-item {
  &.drag-item {
    cursor: move;

    &:hover {
      background: #e7edf2;
      border-color: #d3dde6;
    }
  }

  &:not(.drag-item) {
    cursor: not-allowed;
  }

  &.is-selected {
    background: linear-gradient(90deg, rgba(15, 118, 110, 0.12) 0%, rgba(240, 253, 250, 0.96) 100%);
    border-color: rgba(15, 118, 110, 0.24);
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  }

  .item-icon {
    flex-shrink: 0;
  }

  .item-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .drag-item-check {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    padding: 0 8px;
    border-radius: 999px;
    font-size: 12px;
    color: #0f766e;
    background: rgba(15, 118, 110, 0.14);
  }
}

:deep(.template-tabs) {
  .el-tabs__header {
    margin-bottom: 10px;
  }
  
  .el-tabs__nav-wrap::after {
    display: none;
  }
  
  .el-tabs__nav {
    width: 100%;
    display: flex;
    gap: 10px;
  }
  
  .el-tabs__item {
    flex: 1;
    max-width: 50%;
    text-align: center;
    height: 26px;
    padding: 0;
    line-height: 26px;
    transition: all 0.3s;
    border-radius: 13px;
    border: 1px solid #D4D4D4;
    
    &.is-active {
      border-color: #000000;
    }
  }
  
  .el-tabs__active-bar {
    display: none;
  }
}
</style>

<style lang="scss">
.template-application-category-item {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 40px;
  color: #000;
  background: #EEF2F5;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  padding: 0 10px;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  img {
    width: 100%;
    height: 100%;
    display: block;
    width: 20px;
    height: auto;
    user-select: none;
  }
}
</style>
